import { get } from "lodash"

export const MapperFactory = (map: Object, defaultReturn: any) => {
  return (key = null) => {
    return get(map, key, defaultReturn)
  }
}
